import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {AdminPanelState} from '../../store/reducers/admin-panel.reducer';
import {CompanyModel} from '../../models/company.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'lib-update-company',
  templateUrl: './update-company.component.html',
  styleUrls: ['./update-company.component.scss']
})
export class UpdateCompanyComponent implements OnInit, OnDestroy {

  updateCompanyForm: any;
  updateCompanyFormErrors: any;
  unsubscribe$ = new Subject<void>();
  sourceType = 'Company';
  result: any;

  constructor(public dialogRef: MatDialogRef<UpdateCompanyComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private formBuilder: FormBuilder,
              private store: Store<AdminPanelState>) {
    this.updateCompanyFormErrors = {
      companyName: {},
      description: {},
      /*source: {},*/
      domain: {},
      isActive: {}
    };
    this.result = {
      company: null,
      save: false
    };
  }

  ngOnInit() {
    this.updateCompanyForm = this.formBuilder.group({
      companyName: [this.data.company.CompanyName.displayText, Validators.required],
      description: [this.data.company.Description.displayText],
      /*source: [this.data.company.Source.displayText],*/
      domain: [this.data.company.Domain.displayText],
      isActive: [this.data.company.IsActive.displayText === 'True']
    });

    this.updateCompanyForm.valueChanges.subscribe(() => {
      this.onFormValueChanged();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onFormValueChanged() {
    for (const field in this.updateCompanyFormErrors) {
      if (!this.updateCompanyFormErrors.hasOwnProperty(field)) {
        continue;
      }

      this.updateCompanyFormErrors[field] = {};
      const control = this.updateCompanyForm.get(field);

      if (control && control.dirty && !control.valid) {
        this.updateCompanyFormErrors[field] = control.errors;
      }
    }
  }

  onSave() {
    if (this.updateCompanyForm.valid) {
      this.updateCompanyForm.controls['companyName'].setValue(this.updateCompanyForm.controls['companyName'].value.trim());
      this.updateCompanyForm.controls['description'].setValue(this.updateCompanyForm.controls['description'].value.trim());
      this.updateCompanyForm.controls['domain'].setValue(this.updateCompanyForm.controls['domain'].value.trim());
      this.updateCompanyForm.controls['isActive'].setValue(this.updateCompanyForm.controls['isActive'].value);

      const company = new CompanyModel({
        companyId: this.data.company.CompanyId.displayText,
        companyName: this.updateCompanyForm.value.companyName,
        description: this.updateCompanyForm.value.description,
        registrationDate: this.data.company.RegistrationDate.displayText,
        registeredBy: this.data.userName,
        source: this.data.company.Source.displayText,
        isActive: this.updateCompanyForm.value.isActive,
        domain: this.updateCompanyForm.value.domain
      });

      this.result.save = true;
      this.result.company = company;
    }
  }
}
